module.exports = __webpack_public_path__ + "html/section-video-sign-up_8198953f3ba2208b76d48b5d2fbd720f.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-sign-up.html
// module id = WUbV
// module chunks = 81